import { render, staticRenderFns } from "./UnsubscribeDialog.vue?vue&type=template&id=5e9b36c8"
import script from "./UnsubscribeDialog.vue?vue&type=script&lang=js"
export * from "./UnsubscribeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports